module.exports = __webpack_public_path__ + "img/animals_sheep.18bfc8f8.png";